module.exports = __webpack_public_path__ + "img/4.00fb0d4e.png";